import axios from "axios";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import CryptoJS from 'crypto-js';
import { env } from "../../config/env";
import TermsAndConditionsComponent from "../../component/terms_and_condition/terms_and_conditions_component.jsx";
import TermsAndConditionsComponentFeb2023 from "../../component/terms_and_condition/terms_and_conditions_component_feb_2023.jsx";
import "../../styles/terms_and_conditions.css";
import "../../styles/responsive.css";
import { isExpired } from "react-jwt";
import Header from '../../component/header.jsx';
import { useNavigate } from "react-router-dom";
import PdpaNotice from "../../component/pdpa_notice";
import {
    MdExpandMore, 
    MdExpandLess
  } from 'react-icons/md';
import TermsAndConditionsComponentFeb2024 from "../../component/terms_and_condition/terms_and_conditions_component_feb_2024.jsx";
import PdpaNoticeFeb2024 from "../../component/pdpa_notice_feb_2024.jsx";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import packageJson from '../../../package.json';
import Tnc20230201 from '../../component/terms_and_condition/HomeCare_Terms_Conditions_20230201.pdf';
import Tnc20240801 from '../../component/terms_and_condition/HomeCare_Terms_Conditions_20240801.pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker?url';
import { Spinner } from "reactstrap";

export default function TermsAndConditions() {
    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const pdfjsVersion = packageJson.dependencies['pdfjs-dist'];

    //Variable
    const [tncToken, setTncToken] = useState({});
    const [centre, setCentre] = useState({});
    const [expired, setExpired] = useState(false);
    const [checked, setChecked] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [status, setStatus] = useState();
    const [createdDate, setCreatedDate] = useState();
    const [isTncOpen, setIsTncOpen] = useState(false);
    const [isPdpaOpen, setIsPdpaOpen] = useState(false);
    const navigate = useNavigate();

    //Function
    const loadtnc = async (customerId) => {
        try {
            const response = await axios.get(`${env.API_ENDPOINT_URL}/careadmin/terms-and-conditions?customer_id=${customerId}`);

            if (response.data.success) {
                const tncToken = response.data["token"];
                setTncToken(tncToken);

                const token = tncToken.token;
                const expired = isExpired(token);
                setExpired(expired);

                const centre = response.data["centre"];
                setCentre(centre);
            }
            setIsLoading(false);
        } catch (error) {
            alert(error);
        }
    }

    const handleAccept = async () => {
        setIsLoading(true);
        try{
            const data = {
                customer_id: tncToken.customer_id,
                tnc_status: 1
            }
        
            const response = await axios.put(`${env.API_ENDPOINT_URL}/careadmin/terms-and-conditions`, data)
            
            if(response.data.success){
                const params = (new URL(document.location)).searchParams;
                let customerId = params.get("customerId");
                customerId = customerId?.replace(/ /g,"+") ?? "";
                if(customerId === ""){
                    setIsLoading(false);
                    setStatus(1);
                    return;
                }
                const decrypted = CryptoJS.AES.decrypt(customerId, "CareConcierge");
                customerId = decrypted.toString(CryptoJS.enc.Utf8);

                // loadData(customerId);
                setStatus(1);
                setIsLoading(false);
            }else {
                navigate("/link-expired");
            }

        } catch (error) {
            alert(error);
        }
    }

    const handleReject = async () => {
        setIsLoading(true);
        try{
            const data = {
                customer_id: tncToken.customer_id,
                tnc_status: 0
            }
        
            const response = await axios.put(`${env.API_ENDPOINT_URL}/careadmin/terms-and-conditions`, data)
            
            if(response.data.success){
                const params = (new URL(document.location)).searchParams;
                let customerId = params.get("customerId");
                customerId = customerId?.replace(/ /g,"+") ?? "";
                if(customerId === ""){
                    setIsLoading(false);
                    setStatus(0);
                    return;
                }
                const decrypted = CryptoJS.AES.decrypt(customerId, "CareConcierge");
                customerId = decrypted.toString(CryptoJS.enc.Utf8);

                loadData(customerId);
                setIsLoading(false);
            }else {
                navigate("/link-expired");
            }

        } catch (error) {
            alert(error);
        }
    }

    const loadData = async(customerId) => {
        await loadtnc(customerId);
    }

    const componentRef = useRef();
    
    const handlePrint = useReactToPrint({
        contentRef: componentRef, // Pass the ref object directly
        documentTitle: "Terms and Conditions", // Optional: naming the file
    });

    useEffect(() => {
        
        const params = (new URL(document.location)).searchParams;
        let customerId = params.get("customerId");
        const createdDateValue = params.get("createdDate")? moment(params.get("createdDate")).utc().format("YYYY-MM-DD") : moment(Date()).utc().format("YYYY-MM-DD");
        setCreatedDate(createdDateValue);
        customerId = customerId.replace(/ /g,"+");
        const decrypted = CryptoJS.AES.decrypt(customerId, "CareConcierge");
        customerId = decrypted.toString(CryptoJS.enc.Utf8);
        loadData(customerId);
    }, []);

    //Return
    if (isLoading) {
    return(
        <center>
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden"></span>
            </div>
        </center>
    )
}
    else if (!tncToken){
        navigate("/link-expired");
    }
    else if (expired){
        navigate("/link-expired");
    }
    else if (tncToken.tnc_status === 1 || status === 1){
        return(
            <div style={{marginTop:"20px"}}>
                <Header />
                <div className="t-info-header">
                    Thank you.
                </div>
                <div className="t-info">Terms and Conditions has been accepted.</div>
            </div>
        )
    }
    else if (tncToken.tnc_status === 0 || centre === 6){
        return(
            <div ref={componentRef}> 
                
                <div className="t-content-container" style={{marginTop:"30px"}}>
                    <Header />
                </div>

                <div>
                    <div className="t-header">
                        {
                            tncToken.tnc_status === 0 &&
                            <div className="t-info t-no-print" style={{marginBottom:"20px"}}>You have rejected the Terms and Condition. Please accept the Terms and Conditions to place order.</div>
                        }
                        <div className="t-customer-container">{ `Dear ${tncToken.customer_name},` }</div>
                        <h1 className="t-h1" onClick={() => {setIsTncOpen(!isTncOpen)}} style={{display:'flex', justifyContent:'space-between'}}>
                            Terms and Conditions <span style={{justifyContent:'flex-end', paddingRight: 10, display: 'flex', alignSelf:'center'}}>
                                {
                                isTncOpen ? <MdExpandLess /> : <MdExpandMore />
                            }</span>
                        </h1>
                    </div>
                    <div className="t-content-container">
                        {
                            isTncOpen?
                            ((createdDate >= moment("2024-08-01").utc().format("YYYY-MM-DD"))? 
                            <Worker workerUrl={pdfjsWorker}>
                                <div style={{ height: "720px" }}>
                                    <Viewer 
                                        fileUrl={Tnc20240801} 
                                        plugins={[defaultLayoutPluginInstance]}
                                    />
                                </div>
                            </Worker>
                            : 
                            <Worker workerUrl={pdfjsWorker}>
                                <div style={{ height: "720px" }}>
                                    <Viewer 
                                        fileUrl={Tnc20230201} 
                                        plugins={[defaultLayoutPluginInstance]}
                                    />
                                </div>
                            </Worker>
                            )
                            : <div></div>
                        }
                    </div>

                     <div className="t-header">
                        <h1 className="t-h1" onClick={() => {setIsPdpaOpen(!isPdpaOpen)}} style={{display:'flex', justifyContent:'space-between'}}>
                            Personal Data Protection Act <span style={{justifyContent:'flex-end', paddingRight: 10, display: 'flex', alignSelf:'center'}}>
                                {
                                isPdpaOpen ? <MdExpandLess /> : <MdExpandMore />
                            }</span>
                        </h1>
                    </div>
                    
                    
                    <div className="t-content-container">
                    {isPdpaOpen? <PdpaNoticeFeb2024 /> : <div></div>}
                    </div>
                    

                    <div className="t-content-container">
                        <form method="post" className="t-checkbox-container" style={{flexDirection: 'column'}}>
                            <input className="t-checkbox" type="checkbox" name="agree" value="yes" onClick={(event) => setChecked(event.target.checked)} style={{position:'absolute'}}/>
                            <ol style={{listStyle: 'none'}}>
                                <li>
                                    <div>By checking this box, I hereby confirm that:</div>
                                </li>
                                <br />
                                <li>
                                    <div style={{fontStyle: "italic"}}>Dengan menyemak kotak ini, saya mengesahkan bahawa:</div>
                                </li>
                            </ol>
                            <ol style={{listStyleType: 'decimal'}}>
                                <li>
                                    <div>I have read and understood the Notice and hereby agree to the terms contained in the said Notice and explicitly consent to the Company processing my personal data in the manner stated therein. </div>
                                    <br />
                                    <div style={{fontStyle: "italic"}}>Saya telah membaca dan memahami Notis dan dengan ini bersetuju kepada terma-terma yang terkandung di dalam Notis tersebut dan bersetuju secara nyata pemprosesan data peribadi saya oleh Syarikat mengikut cara yang dinyatakan di dalamnya.</div>
                                    <br />
                                </li>
                                   
                                <li>
                                    <div>I hereby agree to keep my personal data with the Company up-to-date throughout the term of my engagement with the Company. </div>
                                    <br />
                                    <div style={{fontStyle: "italic"}}>Saya dengan ini bersetuju untuk menyimpan data peribadi terkini saya dengan Syarikat sepanjang masa saya berinteraksi dengan Syarikat.</div>
                                    <br />
                                </li>
                            </ol>
                            {/* <label>By checking this box, I hereby confirm that:</label>
                            <label style={{fontStyle: "italic"}}>By checking this box, I hereby confirm that:</label> */}
                        </form>
                    </div>  
                    <hr className="t-no-print t-content-container" />


                    <div className="t-content-container t-no-print">
                        <div style = {{display: "flex", paddingTop: 20}}>
                            <div style = {{flexGrow: 1, paddingBottom: 30}}>
                                <button 
                                    className="t-print-button" 
                                    name="printButton"
                                    value="Print" 
                                    onClick = {handlePrint}
                                >Print</button>
                            </div>
                            <div>
                                
                                <input 
                                    className="t-reject-button"
                                    type="submit" 
                                    name="rejectButton"
                                    value="Reject"
                                    onClick={handleReject} 
                                />
                                
                                <input 
                                    className="t-accept-button"
                                    type="submit"
                                    name="acceptButton"
                                    value="Accept"
                                    disabled={!checked}
                                    onClick={handleAccept}
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )  
    }
    else {
        navigate("/link-expired");
    }
}
